import React from 'react';
import ResourceDetailHeader from 'js/components/ResourceDetailHeader/ResourceDetailHeader';
import { updateDataMap } from 'js/actions';
import { Stack } from 'new/elements/Stack';
import Typography from 'new/elements/Typography';
import { ReactComponent as LookupsIcon } from 'new/components/icons/table-lookup.svg';
import DataMapDetailActionsContainer from 'js/components/data_maps/cards/DataMapDetailActionsContainer';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import useAppDispatch from 'js/hooks/useAppDispatch';

interface DataMapDetailHeaderProps {
  readOnly: boolean;
  adminAccess: boolean;
  hideActions: boolean;
  disableEditing: boolean;
  data: any;
  status: any;
  isEditable: any;
  isDetected: boolean;
  disableEditMessage: any;
  isManaged: any;
  connectionOrVendorType: any;
  statsContentView: any;
  onCloseDrawer?(): void;
}

const BoxInfo = ResourceDetailHeader.TopContent.BoxInfo;

export const DataMapDetailHeader = (props: DataMapDetailHeaderProps) => {
  const { readOnly, adminAccess, data, hideActions } = props;
  const dispatch = useAppDispatch();

  if (!data) {
    return null;
  }

  const updateInfo = (id, info) => {
    dispatch(updateDataMap(data.id, info));
  };

  return (
    <ResourceDetailHeader
      readOnly={readOnly}
      adminAccess={adminAccess}
      data={data}
      updateInfo={updateInfo}
      onCloseDrawer={props?.onCloseDrawer}
    >
      <ResourceDetailHeader.TopContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap="16px">
          <Stack direction="row" alignItems="center" gap="16px">
            <BoxInfo>
              <LookupsIcon />
              <Typography variant="body3">Lookup</Typography>
            </BoxInfo>
            <ChipWithCopy tooltipTitle="Copy Lookup ID" toCopy={data.id}>
              ID {data.id}
            </ChipWithCopy>
          </Stack>
          {!hideActions && (
            <Stack direction="row" alignItems="center" gap="16px">
              <DataMapDetailActionsContainer
                data={data}
                readOnly={readOnly}
                hideMenuDetails={true}
              />
            </Stack>
          )}
        </Stack>
      </ResourceDetailHeader.TopContent>
    </ResourceDetailHeader>
  );
};
